import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as moment from 'moment'

import { Utilservice } from '@core/services/util.service';
import { VisitasService } from "../../services/visitas.service";
import { Visit } from "../../models/visit.interface";

@Component({
  selector: "app-proximos",
  templateUrl: "./proximos.component.html",
  styleUrls: ["./proximos.component.css"]
})
export class ProximosComponent implements OnInit {
  parameters = {
    dataInicial: "",
    dataFinal: "",
    codigoGerencia: "",
    vendedorId: ""
  };

  isRequesting: boolean = true;
  isSetorLoaded: boolean = false;
  isVendedorLoaded: boolean = false;

  lsVisits: Visit[] = [];
  lsVendedores: any[] = [];
  lsSetores: any[] = [];

  userLogado;

  constructor(
    private route: ActivatedRoute,
    private visitService: VisitasService
  ) {}

  ngOnInit() {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));
    this.route.queryParams.subscribe(params => {
      const parameters = { ...this.parameters, ...params };

      this.parameters = parameters;

      if (params.vendedorId) {
        this.getVendedores();
      }

      if (params.agent) {
        this.getSetores();
      }

      if (
        parameters.dataInicial &&
        parameters.dataFinal &&
        (parameters.codigoGerencia || parameters.vendedorId)
      ) {
        Object.keys(parameters).forEach(key => {
          if (parameters[key] === "" || parameters[key] === null) {
            delete parameters[key];
          }
        });

        //parameters.agent = this.userLogado.idSetor;
        this.getListaClientesProximos(parameters);
      }
    });
  }

  getListaClientesProximos(params) {
    this.visitService.getListaClientesProximos(params).subscribe(
      data => {
        console.log('data', data)
        data.sort((a,b)=>{ //ordena pelas cidades
          if(a.cidade > b.cidade){
            return 1;
          }
          if(a.cidade < b.cidade){
            return -1;
          }
          return 0;
        })

        this.lsVisits = data;
        this.lsVisits.forEach(e=>e.cnpj = e.cnpj.toString())
        this.isRequesting = false;
      },
      error => console.log(error),
      () => console.log("States Loaded")
    );
  }

  getVendedores() {
    this.visitService.getVendedores().subscribe(
      data => {
        this.lsVendedores = data;

        this.isVendedorLoaded = true;
      },
      error => console.log(error),
      () => console.log("States Loaded")
    );
  }

  getSetores() {
    this.visitService.getSetores().subscribe(
      data => {
        this.lsSetores = data;

        this.isSetorLoaded = true;
      },
      error => console.log(error),
      () => console.log("States Loaded")
    );
  }

  getSetorName(setor) {
    let setorName = "";

    this.lsSetores.forEach(element => {
      if (String(element.id) === setor) {
        setorName = element.codigo;
      }
    });

    return setorName;
  }

  getVendedorName(vendedor) {
    let vendedorName = "";

    this.lsVendedores.forEach(element => {
      if (String(element.id) === vendedor) {
        vendedorName = element.nome;
      }
    });

    return vendedorName;
  }

  transformDateToHuman(date) {
    return date
      .split("-")
      .reverse()
      .join("/");
  }

  formatDate = date => moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');

  formatCnpj(v) {
    return Utilservice.formatCnpj(v);
  }

  restricaoNome(codigo){
    let nome = '';
    codigo == 0 ? nome = "Sem Restrição": '';
    codigo == 1 ? nome = "Restrição Jolimode" : '';
    codigo == 2 ? nome = "Restrição com o Mercado": '';
    return nome;
  }
}
